export default __webpack_public_path__ + "85f5bd1e428556297e832ef15fee9c8e.svg";